import { getStatusColor } from '../../../../utilities/StatusUtilities';
import { StatusTooltip, AnnotatedStatusTooltip } from '../../tooltip/types';

const metric = (key, label) => ({
    key,
    label,
    color: getStatusColor(key),
    units: '%',
    multiplier: 1,
    forceDecimals: true,
});

const chartTrends = [
    metric('blank', 'Blank'),
    metric('gray', 'No Data'),
    metric('green', 'Normal'),
    metric('yellow', 'Degraded'),
    metric('orange', 'Excessive'),
    metric('red', 'Critical'),
];

export const statusBreakoutDef = {
    title: 'StatusBreakout',
    statusBreakout: true,
    showGranularity: true,
    stacking: true,
    chartType: 'column',
    chartTrends,
};

export const statusDef = {
    tooltip: StatusTooltip,
    title: 'Status',
    stacking: true,
    showGranularity: true,
    chartType: 'column',
    chartTrends,
};

export const annotatedStatusDef = {
    tooltip: AnnotatedStatusTooltip,
    title: 'Status',
    stacking: true,
    showGranularity: true,
    chartType: 'column',
    chartTrends,
};
